import React, {Component} from 'react';
import {Control, Errors} from 'react-redux-form';
import {Checkbox, Col, ControlLabel, FormGroup, Grid, Row} from 'react-bootstrap';

import './styles.css';

class SMSMessage extends Component {
  setSMS = () => {
    this.setState({
      sms: !this.state.sms
    });
  };

  constructor(props) {
    super(props);
    this.state = {
      sms: false,
    };
  }

  render() {
    return (
      <Grid bsClass="container" fluid className="editor">
        <Row>
          <Col md={12}>
            <FormGroup>
              <Control.checkbox
                component={Checkbox}
                model='.sms'
                onChange={this.setSMS}
              >
                SMS
              </Control.checkbox>
            </FormGroup>
            <FormGroup controlId="sms-body">
              <ControlLabel>
                Body*
              </ControlLabel>
              <Control.textarea
                className="form-control"
                model=".sms_body"
                rows="2"
              />

              <Errors
                className="errors"
                model=".sms_body"
                show={{
                  touched: true,
                  focus: false
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default SMSMessage;



// WEBPACK FOOTER //
// ./src/components/admin/notifications/edit/sms-message-editor.jsx